import type { GenderChangeCommandData } from '@festina/legalentity-general-types/legalentity'
import { typeUtils } from '@festina-life/core'
import {
  FormikDatePicker,
  FormikForm,
  FormikSelect,
} from '@festina-life/ui/formikForms'
import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'

import { useEnumOptions } from '../../hooks/useEnumOptions'
import { useHook } from '../../lenteHooks'
import type { CommandDataFormProps } from '../commandActions/CommandDataFormAndSimulation'

const validateKey = typeUtils.createValidator<GenderChangeCommandData>()

export const GenderChangeForm = (
  props: CommandDataFormProps<GenderChangeCommandData>,
) => {
  const translate = useTranslate()
  const translateEnum = useTranslateEnum()

  const informationSources = useHook('pages.crm.useCrmInformationSources')()
  const genderTypes = useEnumOptions('Gender', 'crm')

  return (
    <FormikForm
      initialValues={{
        _type: 'GenderChangeCommandData',
      }}
      {...props}
    >
      <FormikDatePicker
        name={validateKey('changeDate')}
        label={translate('genderChange.field.changeDate')}
      />
      <FormikSelect
        name={validateKey('informationSource')}
        label={translate('card.field.informationSource')}
        options={informationSources}
        renderFn={(x) => translateEnum('legalEntity.enum.InformationSource', x)}
      />
      <FormikSelect
        name={validateKey('gender')}
        label={translate('genderChange.field.gender')}
        options={genderTypes}
        renderFn={(x) => translateEnum('legalEntity.enum.Gender', x)}
      />
    </FormikForm>
  )
}
